import React from "react";
import survey from "../../icons/survey.png";
import design from "../../icons/design.png";
import construct from "../../icons/construct.png";
import handover from "../../icons/handover.png";

const HomeWorkProcess = () => {
  return (
    <div className="homeworkprocess">
      <div className="container">
        <div className="row">
        <div className="col-lg-12 d-flex justify-content-center">
        <div className="label-head  ">
              -- OUR WORK PROCESS --
            </div>
</div>
          <div className="col-lg-12">
          
            <h1 className="text-center">
              Our Work Process :{" "}
              <span className="color-primary">
                Crafting <br />
                Architectural Excellence
              </span>
            </h1>
          </div>
          <div className="col-lg-3">
            <div className="processcard mt-5 ">
              <div className="processcard-image mb-5 align-self-center">
                <img src={survey} alt="" />
                <div className="processcard-number">01</div>
              </div>
              <h3 className="text-center">Survey</h3>
              <p className="text-center">
                A thorough assessment of interior spaces, focusing on layout,
                structural elements, lighting, and utilities. This survey
                ensures accurate design planning, optimal space utilization, and
                seamless integration of functional and aesthetic elements.
              </p>
            </div>
          </div>
          <div className="col-lg-3">
            <div className="processcard mt-5 ">
              <div className="processcard-image mb-5 align-self-center">
                <img src={design} alt="" />
                <div className="processcard-number">02</div>
              </div>
              <h3 className="text-center">Design</h3>
              <p className="text-center">
                Interior design combines aesthetics, functionality, and spatial
                planning to create harmonious, personalized spaces. It
                integrates color, furniture, lighting, and layout to enhance
                comfort, style, and the overall experience of a space.
              </p>
            </div>
          </div>
          <div className="col-lg-3">
            <div className="processcard mt-5 ">
              <div className="processcard-image mb-5 align-self-center">
                <img src={construct} alt="" />
                <div className="processcard-number">03</div>
              </div>
              <h3 className="text-center">Construct</h3>
              <p className="text-center">
                Implementation of design plans, managing construction,
                coordinating contractors, and ensuring timely delivery. It
                ensures quality, precision, and alignment with the envisioned
                design concept.
              </p>
            </div>
          </div>
          <div className="col-lg-3">
            <div className="processcard mt-5 ">
              <div className="processcard-image mb-5 align-self-center">
                <img src={handover} alt="" />
                <div className="processcard-number">04</div>
              </div>
              <h3 className="text-center">Handover</h3>
              <p className="text-center">
                Handover the completed space to the client, ensuring all
                elements meet expectations, providing maintenance guidance, and
                ensuring satisfaction with the final result.
              </p>
            </div>
          </div>
        </div>
      </div>
      <section class="a-section">
    <div class="a-section-marquee-box">
      <h2 class="marquee-text">Residential design *</h2>
      <h2 class="marquee-text">Commercial Design  *</h2>
      <h2 class="marquee-text">Hospitality Design  *</h2>
      <h2 class="marquee-text">Interior Design  *</h2>
      <h2 class="marquee-text">Luxury Furniture </h2>
    </div>
  </section>
    </div>
  );
};

export default HomeWorkProcess;
